// @ts-check
import PatientChooseModal from './PatientChooseModal';

export default PatientChooseModal;
